'use client';


import { Input } from '@nextui-org/react';
import { SearchIcon } from 'lucide-react';

export const MscSearchInput = ({
  setSearchValue,
  searchValue,
}: {
  setSearchValue: (value: string) => void;
  searchValue: string;
}) => {
  const onChange = (e: any) => {
    setSearchValue(e.target.value);
  };

  return (
    <Input
      className="md:max-w-[300px]"
      onClear={() => setSearchValue('')}
      onChange={onChange}
      radius="full"
      size="lg"
      value={searchValue}
      // classNames={{
      //   label: 'text-black/50 dark:text-white/90',
      //   input: [
      //     'bg-transparent',
      //     'text-black/80 dark:text-white/90',
      //     'placeholder:text-default-700/50 dark:placeholder:text-white/60',
      //   ],
      //   innerWrapper: 'bg-transparent',
      //   inputWrapper: [
      //     'shadow-xl',
      //     'bg-default-200/50',
      //     'dark:bg-default/60',
      //     'backdrop-blur-xl',
      //     'backdrop-saturate-200',
      //     'hover:bg-default-200/70',
      //     'dark:hover:bg-default/70',
      //     'group-data-[focus=true]:bg-default-200/50',
      //     'dark:group-data-[focus=true]:bg-default/60',
      //     '!cursor-text',
      //   ],
      /*}}*/
      placeholder="Название мастер-класса..."
      startContent={
        <SearchIcon
          strokeWidth={1.25}
          className="text-black/50 mb-0.5 dark:text-white/90 text-slate-400 pointer-events-none flex-shrink-0"
        />
      }
    />
  );
};
